import { useRef } from "react";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useColorPickerInputStyles } from "./styles";

type Props = TextFieldProps & {
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function ColorPickerInput(props: Props) {
    const inputRef = useRef<HTMLInputElement>(null);
    const { classes } = useColorPickerInputStyles();

    return (
        <TextField
            {...props}
            InputProps={{
                ...props.InputProps,
                endAdornment: (
                    <InputAdornment position="end">
                        <input
                            ref={inputRef}
                            type="color"
                            className={classes.input}
                            value={props.value || "#FFFFFF"}
                            onChange={props.onChange}
                        />
                        <span
                            title={props.value}
                            className={classes.colorBox}
                            onClick={() => inputRef.current?.click()}
                            style={{ background: props.value || "#FFFFFF" }}
                        />
                    </InputAdornment>
                ),
            }}
        />
    );
}
